(function(){
function initBuilder(root){
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var DATA = JSON.parse(root.querySelector('.rnb-data').textContent);

  if (DATA.assetBase && window.RNB_ART.setPhotoBase) window.RNB_ART.setPhotoBase(DATA.assetBase);
  var CAT = window.RNB_CATALOGUE, METALS = CAT.METALS, CHAIN_FALLBACK = CAT.CHAIN_FALLBACK, TABS = CAT.TABS, GEMS = CAT.GEMS;
  var LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

  /* ---------- Merge catalogue with live Shopify variants ---------- */
  function variantMap(product){
    var m = {};
    if (product && product.variants) product.variants.forEach(function(v){
      m[(v.option1 || v.title || '').trim().toLowerCase()] = v;
      m[(v.title || '').trim().toLowerCase()] = v;
    });
    return m;
  }
  var chainVars = variantMap(DATA.chain), letterVars = variantMap(DATA.initials), gemVars = variantMap(DATA.gems);

  var CHARMS = [];
  LETTERS.forEach(function(L){
    var v = letterVars[L.toLowerCase()];
    CHARMS.push({ id: 'L-' + L, key: L, name: 'Initial ' + L, size: '', tab: 'initials', shape: 'letter', letter: L,
      variant: v || null, price: v ? v.price : 18000, img: v && v.featured_image ? v.featured_image.src : null,
      available: v ? v.available !== false : !DATA.initials });
  });
  GEMS.forEach(function(g){
    var v = gemVars[g.key.toLowerCase()];
    var c = Object.assign({}, g, { id: 'G-' + (g.id || g.key), variant: v || null, price: v ? v.price : g.price,
      img: v && v.featured_image ? v.featured_image.src : null, available: v ? v.available !== false : !DATA.gems });
    CHARMS.push(c);
  });
  var BY_ID = {}; CHARMS.forEach(function(c){ BY_ID[c.id] = c; });

  /* ---------- State ---------- */
  var state = { metal: 0, tab: 'initials', charms: [], keys: [] }, keySeq = 0;
  function removeAt(i){ state.charms.splice(i, 1); state.keys.splice(i, 1); renderAll(); }

  /* ---------- Helpers ---------- */
  function money(cents){
    try { return new Intl.NumberFormat('en-AU', { style: 'currency', currency: DATA.currency || 'AUD', minimumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100); }
    catch(e){ return '$' + (cents / 100).toFixed(0); }
  }
  function baseUrl(){ var r = DATA.root || '/'; return r.charAt(r.length - 1) === '/' ? r : r + '/'; }
  function chainVariant(){ return chainVars[METALS[state.metal].key.toLowerCase()] || null; }
  function chainPrice(){ var v = chainVariant(); return v ? v.price : CHAIN_FALLBACK; }

  /* ---------- Charm illustration (drawn in necklace-builder-art.js) ---------- */
  function charmSVG(c, metal, standalone){ return window.RNB_ART.charmSVG(c, metal, standalone); }
  function charmVisual(c, metal){
    return c.img ? '<img src="'+c.img+'" alt="" loading="lazy">' : charmSVG(c, metal, true);
  }

  /* ---------- Render: metals ---------- */
  var elMetals = root.querySelector('.rnb__metals');
  function renderMetals(){
    elMetals.innerHTML = METALS.map(function(m, i){
      var v = chainVars[m.key.toLowerCase()];
      return '<button type="button" class="rnb__metal" role="radio" aria-checked="'+(i===state.metal)+'" data-metal="'+i+'">' +
        '<span class="rnb__dot" style="background:linear-gradient(135deg,'+m.light+','+m.mid+' 55%,'+m.dark+')"></span>' +
        m.key + ' <small>' + money(v ? v.price : CHAIN_FALLBACK) + '</small></button>';
    }).join('');
  }
  elMetals.addEventListener('click', function(e){
    var b = e.target.closest('[data-metal]'); if (!b) return;
    state.metal = +b.dataset.metal; renderAll();
  });

  /* ---------- Render: tabs + grid ---------- */
  var elTabs = root.querySelector('.rnb__tabs'), elGrid = root.querySelector('.rnb__grid');
  function renderTabs(){
    elTabs.innerHTML = TABS.map(function(t){
      return '<button type="button" class="rnb__tab" role="tab" aria-selected="'+(t.id===state.tab)+'" data-tab="'+t.id+'">'+t.label+'</button>';
    }).join('');
  }
  elTabs.addEventListener('click', function(e){
    var b = e.target.closest('[data-tab]'); if (!b) return;
    state.tab = b.dataset.tab; renderTabs(); renderGrid();
  });
  function renderGrid(){
    var full = state.charms.length >= DATA.maxCharms, metal = METALS[state.metal];
    elGrid.classList.toggle('is-letters', state.tab === 'initials');
    elGrid.innerHTML = CHARMS.filter(function(c){ return c.tab === state.tab; }).map(function(c){
      var n = state.charms.filter(function(id){ return id === c.id; }).length;
      var label = c.shape === 'letter' ? '' : (c.month && state.tab === 'gems' ? '<em>'+c.month+'</em>' : '') + '<b>'+c.name+'</b><span>'+c.size+' · '+money(c.price)+'</span>';
      var title = (c.month && state.tab === 'gems' ? c.month + ' birthstone: ' : '') + c.name + (c.size ? ' ' + c.size : '') + ', ' + money(c.price);
      return '<button type="button" class="rnb__charm'+(n?' has-count':'')+'" data-charm="'+c.id+'" title="'+title+'" aria-label="Add '+title+'"'+(full||!c.available?' disabled':'')+'>' +
        '<i>'+n+'</i>' + charmVisual(c, metal) + label + '</button>';
    }).join('') + (state.tab === 'initials' ? '<p style="grid-column:1/-1;margin:4px 0 0;font-size:13px;color:#6f6a63">Initials '+money(CHARMS[0].price)+' each</p>' : '');
  }
  elGrid.addEventListener('click', function(e){
    var b = e.target.closest('[data-charm]'); if (!b || b.disabled) return;
    if (state.charms.length >= DATA.maxCharms) return;
    state.charms.push(b.dataset.charm); state.keys.push(++keySeq); renderAll();
  });

  /* ---------- Render: necklace preview (animated) ----------
     Each charm is a node on a damped spring heading for its resting spot. The chain is drawn through the nodes;
     where two nodes are closer than their resting distance the chain between them goes slack and sags.
     Stones on jump rings swing with the sideways motion. Turned off for people who prefer reduced motion. */
  var elSvg = root.querySelector('.rnb__svg'), elEmpty = root.querySelector('.rnb__empty');
  var P0 = [34, -6], P1 = [200, 440], P2 = [366, -6];
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var nodes = [], chainG, charmsG, raf = 0, lastT = 0;
  function qp(t){
    var a = (1-t)*(1-t), b = 2*(1-t)*t, c = t*t;
    return [a*P0[0]+b*P1[0]+c*P2[0], a*P0[1]+b*P1[1]+c*P2[1]];
  }
  function targets(){
    var n = state.charms.length, step = n > 1 ? Math.min(.14, .62 / (n - 1)) : 0;
    return state.charms.map(function(id, j){ return qp(.5 + (j - (n - 1) / 2) * step); });
  }
  function dist(a, b){ var dx = b[0] - a[0], dy = b[1] - a[1]; return Math.sqrt(dx * dx + dy * dy); }
  /* Chain anchor points. A charm set in line (pear) is a rigid link: the chain joins its two end loops, so it
     contributes two points, `span` either side of its centre along the chain's direction. */
  function angleAt(list, j){
    var prev = j ? list[j - 1] : P0, next = j < list.length - 1 ? list[j + 1] : P2;
    return Math.atan2(next[1] - prev[1], next[0] - prev[0]);
  }
  function expand(list){
    var out = [P0];
    list.forEach(function(p, j){
      var sp = nodes[j].a.span;
      if (sp){ var r = angleAt(list, j), dx = Math.cos(r) * sp * .85, dy = Math.sin(r) * sp * .85; out.push([p[0] - dx, p[1] - dy], [p[0] + dx, p[1] + dy]); }
      else out.push(p);
    });
    out.push(P2);
    return out;
  }
  /* chain points through the nodes, sagging where a run is slack */
  function chainPoints(){
    if (!nodes.length){ var u = []; for (var i = 0; i <= 48; i++) u.push(qp(i / 48)); return u; }
    var cur = expand(nodes.map(function(o){ return [o.x, o.y]; }));
    var rest = expand(nodes.map(function(o){ return [o.tx, o.ty]; }));
    var pts = [cur[0]];
    for (var k = 0; k < cur.length - 1; k++){
      var a = cur[k], b = cur[k + 1], L = dist(rest[k], rest[k + 1]), d = dist(a, b);
      var sag = d < L ? Math.sqrt(L * L - d * d) * .55 : 0;
      var mx = (a[0] + b[0]) / 2, my = (a[1] + b[1]) / 2 + sag;
      var segs = sag > .5 ? 10 : 1;
      for (var s2 = 1; s2 <= segs; s2++){
        var t = s2 / segs, q = 1 - t;
        pts.push([q*q*a[0] + 2*q*t*mx + t*t*b[0], q*q*a[1] + 2*q*t*my + t*t*b[1]]);
      }
    }
    return pts;
  }
  function draw(){
    var m = METALS[state.metal], cur = nodes.map(function(o){ return [o.x, o.y]; });
    chainG.innerHTML = window.RNB_ART.links(chainPoints(), m);
    nodes.forEach(function(o, j){
      var deg = o.a.follow ? angleAt(cur, j) * 180 / Math.PI - (o.a.tilt || 0) : o.ang;
      o.el.setAttribute('transform', 'translate(' + o.x.toFixed(2) + ',' + o.y.toFixed(2) + ') rotate(' + deg.toFixed(2) + ') scale(.85) translate(' + (-o.a.x) + ',' + (-o.a.y) + ')');
    });
  }
  function step(t){
    var dt = Math.min(.033, (t - (lastT || t)) / 1000 || .016), moving = false;
    lastT = t;
    nodes.forEach(function(o){
      var ax = 170 * (o.tx - o.x) - 13 * o.vx, ay = 170 * (o.ty - o.y) - 13 * o.vy;
      o.vx += ax * dt; o.vy += ay * dt; o.x += o.vx * dt; o.y += o.vy * dt;
      if (!o.a.follow){
        o.va += (-120 * o.ang - 6 * o.va - ax * .06) * dt;
        o.ang = Math.max(-28, Math.min(28, o.ang + o.va * dt));
      }
      if (Math.abs(o.vx) + Math.abs(o.vy) > .4 || Math.abs(o.tx - o.x) + Math.abs(o.ty - o.y) > .15 || Math.abs(o.ang) > .15 || Math.abs(o.va) > .4) moving = true;
    });
    if (!moving) nodes.forEach(function(o){ o.x = o.tx; o.y = o.ty; o.vx = o.vy = o.va = o.ang = 0; });
    draw();
    raf = moving ? requestAnimationFrame(step) : 0;
  }
  function renderPreview(){
    var m = METALS[state.metal], tg = targets(), old = {};
    nodes.forEach(function(o){ old[o.key] = o; });
    var added = false;
    nodes = state.charms.map(function(id, j){
      var key = state.keys[j], o = old[key];
      if (!o){ o = { key: key, x: tg[j][0], y: tg[j][1] - 22, vx: 0, vy: 0, ang: 0, va: 0 }; added = true; }
      o.id = id; o.tx = tg[j][0]; o.ty = tg[j][1];
      return o;
    });
    if (added) nodes.forEach(function(o){ o.vy += 35; o.va += (Math.random() - .5) * 60; });
    elSvg.innerHTML = '<g class="rnb-chain"></g><g class="rnb-charms"></g>';
    chainG = elSvg.firstChild; charmsG = elSvg.lastChild;
    nodes.forEach(function(o, j){
      var c = BY_ID[o.id];
      o.a = c.img ? { x: 30, y: 7, follow: false } : window.RNB_ART.anchor(c);
      var inner = c.img ? '<image href="'+c.img+'" x="0" y="0" width="60" height="60" preserveAspectRatio="xMidYMid meet"/>' : charmSVG(c, m, false);
      var g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      g.setAttribute('class', 'rnb-hang'); g.setAttribute('data-index', j);
      g.innerHTML = '<title>Remove ' + c.name + '</title><rect x="10" y="0" width="40" height="50" fill="transparent"/>' + inner;
      charmsG.appendChild(g); o.el = g;
    });
    elEmpty.style.display = nodes.length ? 'none' : '';
    if (reduceMotion || document.hidden){ settle(); return; }
    draw();
    if (!raf){ lastT = 0; raf = requestAnimationFrame(step); }
  }
  function settle(){
    if (raf){ cancelAnimationFrame(raf); raf = 0; }
    nodes.forEach(function(o){ o.x = o.tx; o.y = o.ty; o.vx = o.vy = o.va = o.ang = 0; });
    if (chainG) draw();
  }
  document.addEventListener('visibilitychange', settle);
  elSvg.addEventListener('click', function(e){
    var g = e.target.closest('[data-index]'); if (!g) return;
    removeAt(+g.dataset.index);
  });

  /* ---------- Render: summary ---------- */
  var elLines = root.querySelector('.rnb__lines'), elTotal = root.querySelector('.rnb__total-val'),
      elAdd = root.querySelector('.rnb__add'), elMsg = root.querySelector('.rnb__msg'), elCount = root.querySelector('.rnb__count');
  function renderSummary(){
    var m = METALS[state.metal], total = chainPrice();
    var rows = '<li><span>45cm chain — '+m.key+'</span><span>'+money(chainPrice())+'</span></li>';
    state.charms.forEach(function(id, i){
      var c = BY_ID[id]; total += c.price;
      rows += '<li><span>'+c.name+(c.size?' '+c.size:'')+'<button type="button" data-remove="'+i+'">Remove</button></span><span>'+money(c.price)+'</span></li>';
    });
    elLines.innerHTML = rows;
    elTotal.textContent = money(total);
    elCount.textContent = state.charms.length + ' of ' + DATA.maxCharms + ' charms';
    var ready = state.charms.length > 0 && chainVariant() && state.charms.every(function(id){ return BY_ID[id].variant; });
    elAdd.disabled = !ready;
    if (!state.charms.length) elMsg.textContent = '';
    else if (!ready && window.Shopify && window.Shopify.designMode) elMsg.textContent = 'Preview mode: select the chain, initial and gemstone products in the section settings to enable checkout.';
  }
  elLines.addEventListener('click', function(e){
    var b = e.target.closest('[data-remove]'); if (!b) return;
    removeAt(+b.dataset.remove);
  });

  /* ---------- Add to cart ---------- */
  elAdd.addEventListener('click', function(){
    var m = METALS[state.metal], build = 'NB-' + Date.now().toString(36).slice(-5).toUpperCase();
    var summary = state.charms.map(function(id){ var c = BY_ID[id]; return c.name + (c.size ? ' ' + c.size : ''); }).join(', ');
    var items = [{ id: chainVariant().id, quantity: 1, properties: { 'Necklace build': build, 'Charms (in order)': summary } }];
    state.charms.forEach(function(id, i){
      items.push({ id: BY_ID[id].variant.id, quantity: 1, properties: { 'Necklace build': build, 'Metal': m.key, 'Position': String(i + 1) } });
    });
    elAdd.disabled = true; elAdd.textContent = 'Adding…'; elMsg.textContent = '';
    fetch(baseUrl() + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); })
      .then(function(){
        if (DATA.afterAdd === 'stay'){
          elAdd.textContent = 'Added ✓'; document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(function(){ elAdd.textContent = 'Add to bag'; renderSummary(); }, 2000);
        } else { window.location.href = baseUrl() + 'cart'; }
      })
      .catch(function(err){
        elMsg.textContent = (err && (err.description || err.message)) || 'Sorry, something went wrong. Please try again.';
        elAdd.textContent = 'Add to bag'; renderSummary();
      });
  });

  function renderAll(){ renderMetals(); renderTabs(); renderGrid(); renderPreview(); renderSummary(); }
  renderAll();
}
function initAll(){ document.querySelectorAll('.rnb').forEach(initBuilder); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
document.addEventListener('shopify:section:load', function(e){ initBuilder(e.target.querySelector('.rnb')); });
})();
